<template>
    <div class="main-body">
        <cabecalho-padrao/>
    
        <section class="sub-menu-body">
            <sub-menu/>
            <div class="main">
                <div class="relatorio">
                  <h1>Despesas semanal</h1>
                  <br>
                  <div class="selecionar-mes">
                    <button @click="pesquisa(-2)">anterior</button>
                    <h2>{{ tabelaJson.nome_mes}}</h2>
                    <button @click="pesquisa(0)">Proximo</button>
                  </div>                 

                    <div class="table-container">

                      <table>
                        <thead>
                            <tr>
                                <th class="-esquerda">Data</th>        
                                <th>Total Por Semana(Cartão)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="semana in tabelaJson.semanas" :key="semana.id">
                               <td class="-esquerda">{{ formatarData(semana.data_fim) }}</td>            
                                <td>
                                  R${{formatarValor(semana.total_por_semana)}} 
                                  <button @click="semana.mostrar_detalhe=!semana.mostrar_detalhe"><span v-if="semana.mostrar_detalhe">-</span><span v-if="!semana.mostrar_detalhe">+</span></button>
                                  <div class="valor-detalhe" v-if="semana.mostrar_detalhe">
                                    <span class="linha">
                                      <label>Compra/Feira</label>
                                      <h3>R${{formatarValor(semana.compra_feira)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Açougue</label>                                    
                                      <h3>R${{formatarValor(semana.acougue)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Gasolina/Ônibus</label>                                                                          
                                      <h3>R${{formatarValor(semana.gasolina_onibus)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Farmácia/Saúde</label>                                                                          
                                      <h3>R${{formatarValor(semana.farmacia_saude)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Gasto Carro</label>                                                                          
                                      <h3>R${{formatarValor(semana.gasto_carro)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Viagem/Lazer</label>                                                                          
                                      <h3>R${{formatarValor(semana.viagem_lazer)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Comer Fora</label>                                                                          
                                      <h3>R${{formatarValor(semana.comer_fora)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Compra Casa</label>                                                                          
                                      <h3>R${{formatarValor(semana.compra_casa)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Outros</label>                                                                          
                                      <h3>R${{formatarValor(semana.outros)}}</h3>                               
                                    </span>
                                  </div>
                                </td>
                            </tr> 
                            <tr>
                                <th>Total Mês</th>           
                                <th>
                                  R${{formatarValor(tabelaJson.total_mes.total_por_semana)}}
                                  <button @click="tabelaJson.total_mes.mostrar_detalhe=!tabelaJson.total_mes.mostrar_detalhe"><span v-if="tabelaJson.total_mes.mostrar_detalhe">-</span><span v-if="!tabelaJson.total_mes.mostrar_detalhe">+</span></button>
                                  <div class="valor-detalhe" v-if="tabelaJson.total_mes.mostrar_detalhe">
                                    <span class="linha">
                                      <label>Compra/Feira</label>
                                      <h3>R${{formatarValor(tabelaJson.total_mes.compra_feira)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Açougue</label>                                    
                                      <h3>R${{formatarValor(tabelaJson.total_mes.acougue)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Gasolina/Ônibus</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.gasolina_onibus)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Farmácia/Saúde</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.farmacia_saude)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Gasto Carro</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.gasto_carro)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Viagem/Lazer</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.viagem_lazer)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Comer Fora</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.comer_fora)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Compra Casa</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.compra_casa)}}</h3>
                                    </span>
                                    <span class="linha">
                                      <label>Outros</label>                                                                          
                                      <h3>R${{formatarValor(tabelaJson.total_mes.outros)}}</h3>                               
                                    </span>
                                  </div>                                  
                                </th>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="totais">
                      <div class="colunas">
                        <h1>Totais</h1>
                        <div class="linha">
                          <label>Receitas</label>
                          <h2>R${{formatarValor(total.VlReceita)}}</h2>
                        </div>     
                        <div class="linha">
                          <label>Despesas</label>
                          <h2>R${{formatarValor(total.VlGastoFim)}}</h2>
                        </div>                                          
                        <div class="linha">
                          <label>Saldo</label>
                          <h2>R${{formatarValor(total.VlSaldo)}}</h2>
                        </div>                       
                      </div>  
                      <div class="colunas">
                        <h1>Totais Projetado</h1>
                        <div class="linha">
                          <label>Receitas</label>
                          <h2>R${{formatarValor(total.VlReceita)}}</h2>
                        </div>     
                        <div class="linha">
                          <label>Despesas incial</label>
                          <h2>R${{formatarValor(total.VlGastoInicio)}}</h2>
                        </div>                                          
                        <div class="linha">
                          <label>Despesa Projetado</label>
                          <h2>R${{formatarValor(total.VlDespesaProjetado)}}</h2>
                        </div>
                        <div class="linha">
                          <label>Saldo projetado</label>
                          <h2>R${{formatarValor(total.VlSaldoProjetado)}}</h2>
                        </div>                        
                      </div>                 
                    </div>    
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import api from '../../services/api.js';
import CabecalhoPadrao from '../../components/Cabecalho.vue';
import subMenuMais from '../../components/subMenuMais.vue';
import { onMounted } from 'vue';
export default {
  name: 'Mais',
  components:{
    'cabecalho-padrao': CabecalhoPadrao,
    'sub-menu': subMenuMais
  },
  data: () => ({
    dataAtual:new Date(),
    tabelaJson: {
          nome_mes:'Mes-Ano',            
          semanas: [],
          total_mes: {
              compra_feira:0,
              acougue:0,
              gasolina_onibus:0,
              farmacia_saude:0,
              gasto_carro:0,
              viagem_lazer:0,
              comer_fora:0,
              compra_casa:0,
              outros:0,
              total_por_semana:0
          }
      },
    total: {
        VlReceita: 0,
        VlGastoInicio: 0,
        VlGastoFim: 0,
        VlSaldo: 0,
        VlDespesaProjetado: 0,
        VlSaldoProjetado: 0
    }      

  }),
  methods:{
      formatarValor(v){
        var format = new Intl.NumberFormat('pt-BR', {minimumFractionDigits: 2});                                    
        return format.format(v);
      },
      formatarData(data){
        return data.replace(/-/g, '/');
      },        
      formatarDataUrl(data){
        const dia = data.getDate().toString().padStart(2, '0');
        const mes = (data.getMonth()+1).toString().padStart(2, '0');
        const ano = data.getFullYear().toString();
        return  `${dia}${mes}${ano}`;
      },    
      async pesquisa(somaData){       

          let mes = this.dataAtual.getMonth();
          console.log('mes '+mes+' somaData '+(somaData));

          mes = this.dataAtual.getMonth()+somaData;

          console.log('mes '+mes+' somaData '+(somaData));

          this.dataAtual.setMonth(mes); 

          console.log('data pesquisa '+(this.dataAtual));
        
          await this.pesquisar(this.dataAtual);
          await this.valoresTotal(this.dataAtual);
      },
      async pesquisar(data) {
        try {
            console.log('data '+this.formatarDataUrl(data));

            let url = `/pagar/relatorio/resumosemana/${this.formatarDataUrl(data)}`;
            const response = await  api.get(url); // Aguarda a resposta da API
            if (response.data.erro=='')
               this.tabelaJson = response.data.qry
            else
                alert(response.data.erro);

        } catch (error) {
            console.log(error);
            alert('Error - listar \n' + '-' + error.response?.data || error.message);
        }
      },
      async valoresTotal(data) {
        try {
            data.setMonth(data.getMonth()+1); 
            let url = `grafico/mes/${this.formatarDataUrl(data)}`;
            const response = await api.get(url); // Aguarda a resposta da API


            this.total.VlReceita = response.data.vl_receita;
            this.total.VlGastoInicio = response.data.vl_gasto_inicio;
            this.total.VlGastoFim = response.data.vl_gasto_fim;
            this.total.VlSaldo = response.data.saldo;      
            
            this.total.VlDespesaProjetado = this.total.VlGastoInicio+this.tabelaJson.total_mes.total_por_semana;
            this.total.VlSaldoProjetado = this.total.VlReceita-(this.total.VlGastoInicio+this.tabelaJson.total_mes.total_por_semana);

        } catch (error) {
            console.log(error);
            alert('Error - listar \n' + '-' + error.response?.data || error.message);
        }
      }      
  },
  mounted(){
    this.dataAtual = new Date();
    this.dataAtual.setDate(1); //define dia 1
    console.log('data inicio '+(this.dataAtual));
    this.pesquisa(0);
 
  }
}
</script>

<style>
  @import '../../css/components/sub-menu-body.css';
  @import '../../css/components/report-table.css';

</style>